import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NumberPipe } from '@capital-access/common/formatting';
import { BadgeSize } from '@capital-access/common/utils';

/**
 * `TargetingCommonModule` has to be imported in order to use `ca-purchasing-power-badge` component
 *
 * In case the value in the badge doesn't fit into the allocated area, the value will be truncated,
 * and by hover on the badge the browser tooltip full value will be shown.
 */
@Component({
  selector: 'ca-purchasing-power-badge',
  templateUrl: './purchasing-power-badge.component.html',
  styleUrls: ['./purchasing-power-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchasingPowerBadgeComponent {
  /**
   * Badge value. In case of having `null` badge will not appear.
   */
  @Input() value!: number | null;
  /**
   * String which determines badge size
   */
  @Input() size: BadgeSize = BadgeSize.Xs;
  @Input() rootCssClass = '';

  constructor(private caNumber: NumberPipe) {}

  get formattedValue() {
    return this.caNumber.transform(this.value);
  }
}
